import {AuthenticationError} from './AuthenticationError.js'

export class GenericAuthenticationrError extends AuthenticationError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new GenericAuthenticationrError({
      message
    })
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {message: this.#message}
  }
}
